import {has, omit} from 'lodash'
import {
    SET_FETCHING_VEHICLES,
    SET_INVENTORY_VEHICLES,
    UPDATE_INVENTORY_VEHICLE
} from "@/store/modules/vehicle/mutations";

export const FETCH_INVENTORY_VEHICLES = 'fetchInventoryVehicles'
export const CHANGE_VEHICLE_VISIBILITY = 'changeVehicleVisibility'
export const SAVE_INVENTORY_VEHICLE = 'saveInventoryVehicle'
export const CLEAR_INVENTORY_VEHICLES = 'clearInventoryVehicles'

export default {
    async [FETCH_INVENTORY_VEHICLES]({commit, state: {queryKeys}}, params) {
        let filter = {
            dealership_listing_only: 1,
        };
        let axiosParams = {
            ...omit(params, queryKeys),
            include: 'topImages,company,condition,color',
        }
        if (has(params, 'vehicle_make_id')) {
            filter.vehicle_make_id = params.vehicle_make_id;
        }
        if (has(params, 'vehicle_model_id')) {
            filter.vehicle_model_id = params.vehicle_model_id;
        }
        if (has(params, 'vehicle_year_range')) {
            filter.year_range = params.vehicle_year_range;
        }
        if (has(params, 'vehicle_mileage_range')) {
            filter.mileage_range = params.vehicle_mileage_range;
        }
        if (has(params, 'vehicle_price_range')) {
            filter.price_range = params.vehicle_price_range;
        }
        if (has(params, 'condition_id')) {
            filter.condition_id = params.condition_id;
        }
        if (has(params, 'visibility')) {
            filter.visibility = params.visibility;
        } else {
            filter.with_hidden = 1;
        }
        if (has(params, 'stock_id')) {
            filter.stock_id = params.stock_id;
        }
        axiosParams.filter = filter;
        if (has(params, 'sort')) {
            axiosParams.sort = params.sort;
        }

        commit(SET_FETCHING_VEHICLES, true)
        return axios.get('/web-api/vehicle', {
            params: axiosParams,
        })
            .then(({data}) => {
                commit(SET_INVENTORY_VEHICLES, data)
            })
            .finally(() => {
                commit(SET_FETCHING_VEHICLES, false)
            })
    },
    async [CLEAR_INVENTORY_VEHICLES]({commit}) {
        commit(SET_INVENTORY_VEHICLES, {
            data: [],
            meta: {},
        })
    },
    async [SAVE_INVENTORY_VEHICLE]({commit}, {vehicle, form}) {
        return axios.put(`/web-api/vehicle/${vehicle.id}`, form)
            .then(() => {
                commit(UPDATE_INVENTORY_VEHICLE, {vehicle, newVehicle: form, fields: ['assignee_id']})
            })
    },
    async [CHANGE_VEHICLE_VISIBILITY]({commit}, {vehicle, hide}) {
        return axios.post(`/web-api/vehicle/${vehicle.id}/hide`, {
            hide
        })
            .then(() => {
                let hid_at = hide ? new Date() : null
                commit(UPDATE_INVENTORY_VEHICLE, {vehicle, newVehicle: {hid_at}, fields: ['hid_at']})
            })
    },
}
